import React from 'react'

import { styleInput } from './styleInput'
import { useMemo } from 'react'

const Input = ({
    title,
    name,
    refInput,
    type,
    value,
    error,
    onChange,
    isDisabled,
    placeholder,
}) => {
    const InputLabelWrapperMemoSC = useMemo(() => {
        return (
            <InputLabelWrapperSC>
                <InputTitleSC>{title}</InputTitleSC>
                <InputErrorSC>{error}</InputErrorSC>
            </InputLabelWrapperSC>
        )
    }, [title, error])
    return (
        <>
            {InputLabelWrapperMemoSC}
            <InputSC
                ref={refInput}
                disabled={isDisabled}
                name={name}
                type={type}
                value={value}
                onChange={(e) => onChange(e)}
                placeholder={placeholder}
            />
        </>
    )
}

const { InputSC, InputErrorSC, InputTitleSC, InputLabelWrapperSC } =
    styleInput()

export default React.memo(Input)
